'use strict';

wbApp.controller('TerminalsCtrl', ['$scope', '$modal', '$translate', 'terminalSvc',
function ($scope, $modal, $translate, terminalSvc) {

    $scope.terminals = terminalSvc.getAllAsync(true);

    $scope.gridSettings = {
        columns: [
            { dataField: 'name', caption: $translate.instant('TXT_LBL_NAME'), dataType: 'string', sortOrder: 'asc' },
            { dataField: 'description', caption: $translate.instant('TXT_LBL_DESCRIPTION'), dataType: 'string' },
        ],
        onRowPrepared: function (e) {
            if (e.rowType == "data") {
                var data = e.component.getKeyByRowIndex(e.rowIndex);
                if (data.buildIn) {
                    e.rowElement.addClass('text-muted');
                }
            }
        }
    }

    $scope.$on('refreshData', function (e, data) {
        $scope.terminals = terminalSvc.getAllAsync(true);
    });

    $scope.onRowEdit = function (data) {
        detailDialogPromise.$promise.then(function () {
            detailDialogPromise.$scope.model = angular.copy(data);
            detailDialogPromise.show();
        });
    }

    $scope.onRowAdd = function () {
        detailDialogPromise.$promise.then(function () {
            detailDialogPromise.$scope.model = terminalSvc.createNew();
            detailDialogPromise.show();
        });
    }

    $scope.onRowDelete = function (data) {
        terminalSvc.remove(data);
    }
    
    var detailDialogPromise = $modal({
        templateUrl: 'setting/terminals/terminals-detail.html',
        show: false,
        scope: $scope.$new()
    });
}]);
